import {CountryAlpha3CodeEnum} from '@dms/api/shared';

export const isPolishTenant = (country: CountryAlpha3CodeEnum) => country === 'POL';
